import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SvgSprite from '../../../../atoms/svg-sprite/SvgSprite.jsx';
import SearchAuto from '../../../../atoms/search-auto/javascripts/components/SearchInput.jsx';

const SearchTrigger = ({ iconId, toggleSearch, className }) => (
  <button type="button" className="o-header__search-trigger" onClick={toggleSearch}>
    <SvgSprite id={iconId} title={iconId} className={className} />
  </button>
);

const Search = ({ search }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleSearch = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="o-header__search">
      <SearchTrigger
        iconId="default-search"
        toggleSearch={toggleSearch}
        className="a-svg-sprite--default-search-small"
      />
      {expanded && (
        <div className="a-search-auto a-search-auto--navigation-input o-header__search-auto">
          <div className=" l-container l-container--has-margin">
            <div className="l-container__wrapper">
              <div className="l-container__grid">
                <SearchAuto data={search} type="Search_Main" />
                <SearchTrigger iconId="default-close" toggleSearch={toggleSearch} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

SearchTrigger.propTypes = {
  iconId: PropTypes.string.isRequired,
  toggleSearch: PropTypes.func.isRequired,
  className: PropTypes.string
};

SearchTrigger.defaultProps = {
  className: null
};

Search.propTypes = {
  search: PropTypes.shape().isRequired
};

export default Search;
